import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";
import { Cookies } from "react-cookie";

export const userResetPin = createAsyncThunk("userResetPin", async (data) => {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");
    const response = await AxiosInstance.post(`${API_KEY}/api/user/reset-pin`, data, {
      headers: { Authorization: `Barear ${token}` },
      "Content-Type": "application/json",
    });

    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data.message;
    } else {
      throw error;
    }
  }
});

const initialState = {
  isLoading: false,
  userResetPinData: null,
  isError: false,
  errorMessage: "",
};
const userResetPinSlice = createSlice({
  name: "userResetPin",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(userResetPin.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(userResetPin.fulfilled, (state, action) => {
      state.isLoading = false;
      state.userResetPinData = action.payload;
    });
    builder.addCase(userResetPin.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default userResetPinSlice.reducer;
